import { Box, Typography } from "@mui/material";
import React from "react";
import BadgeStatus from "../BadgeStatus";

interface Props {
  getStep: (index: number) => void;
  data: {
    index: number;
    title: string;
    status: "done" | "pending" | "inprogress";
  };
}

export default function StepsItem({ data, getStep }: Props) {
  return (
    <Box
      onClick={() => getStep(data.index)}
      sx={{
        // border: "1px solid gray",
        flex: 1,
        display: "flex",
        flexDirection: "column",
        gap: "4px",
      }}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
        }}
      >
        <Box
          sx={{
            width: "32px",
            height: "32px",
            borderRadius: "50%",
            // border: "1px solid gray",
            flexShrink: 0,
            color: "#ffffff",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            backgroundColor:
              data.status === "inprogress" ? "secondary.main" : "info.main",
          }}
        >
          <Typography
            sx={{
              fontSize: "16px",
            }}
          >
            {data.index}
          </Typography>
        </Box>
        {data.index !== 4 && (
          <hr
            style={{
              width: "100%",
            }}
          />
        )}
      </Box>
      <Typography
        sx={{
          fontSize: "11px",
        }}
      >
        {data.title}
      </Typography>
      <BadgeStatus
        size="small"
        status={data.status}
        text={data.status === "inprogress" ? "در حال انجام" : "در انتظار"}
      />
    </Box>
  );
}
